import { createFileRoute } from "@tanstack/react-router";
import ElectricHub from "@/pages/hub/ElectricHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/hub/electric/")({
  head: () => routeHead("/uk/hub/electric/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ElectricHub />
  );
}
